<template>
	<k-list closeOnClick v-if="is_search_results" :items="results" @click="open">
		<template #default="{ item }">
			<k-layout>
				<k-flex c3 style="width: 80px;">{{date(item)}}</k-flex>
				<k-flex c9 class="ks-font-size-s">{{title(item)}}</k-flex>
			</k-layout>
		</template>
		<template #subtitle="{ item }">
			<k-layout>
				<k-flex c3 style="width: 80px;">{{time(item)}}</k-flex>
				<k-flex c9 class="ks-font-size-s">{{subtitle(item)}}</k-flex>
			</k-layout>
			<k-divider/>
		</template>
	</k-list>
</template>

<script>
import EventModel from '@/models/event.js'

export default {
	props: ["url-prefix"],
	data () {
		return {
			channel: undefined,
			results: [],
		}
	},
	watch: {
		search () {
			var self = this;
			var text = this.search;
			if (this.channel && text != null && text.length > 2) {
				this.channel.push("search", {search: text})
					.receive("ok", (msg) => {
						if (self.search === text) self.results = msg.results;
					})
			}
		}
	},
	computed: {
		search () {
			return this.$store.state.search_text;
		},
		is_search_results () {
			if (this.search == null) return false;
      if (this.search.length > 2) return true;
      return false;
    },
	},
	methods: {
		open (event) {
			var url = "/dashboard/event/"
			if (typeof(this.urlPrefix) != "undefined" && this.urlPrefix != null) {
				url = this.urlPrefix;
			}

			this.$router.push(url + event.uuid);
		},
		title (event) {
			return EventModel.title(event);
		},
		subtitle (event) {
			return EventModel.subtitle(event);
		},
		date (event) {
			return EventModel.formatted_date(event);
		},
		time (event) {
			return EventModel.formatted_time(event);
		},
		ws_connect() {
			var self = this;
	    this.channel = this.$cloudserver.channel("events:search");
    	this.channel.join();
		}
	},
	mounted () {
		this.ws_connect();
	},
	beforeDestroy () {
		this.channel.leave();
	}
}
</script>